export const images = {
  logo: "https://cdn.magicpatterns.com/patterns/generated-images/d6272a6c-77a6-42f6-8918-600b8ff187b4.jpg",
  hero: "https://cdn.magicpatterns.com/patterns/generated-images/08ea675d-ffed-4d52-880c-64740d23f3fb.jpg",
  pool: "https://cdn.magicpatterns.com/patterns/generated-images/7f8a5372-6e50-4838-90d5-4f9e4d90d047.jpg",
  room: "https://cdn.magicpatterns.com/patterns/generated-images/b1ab89ce-5308-4b8a-b632-0f08d6c3fe85.jpg",
  breakfast: "https://cdn.magicpatterns.com/patterns/generated-images/a491c2da-9ccb-4e30-9c1f-f643250d3a13.jpg",
  bay: "https://cdn.magicpatterns.com/patterns/generated-images/d9488fe7-fce0-4b2e-80fd-ee7fb91abcde.jpg",
  house: "https://cdn.magicpatterns.com/patterns/generated-images/d049b5bb-7b5b-4f92-a4c7-7debc773ea05.jpg",
  hammock: "https://cdn.magicpatterns.com/patterns/generated-images/37340081-fa3d-4f2b-868f-f9eb17fc698a.jpg",
};
